import AGGridColumn from "@/utils/UIConstants/AGGridColumns/AGGridColumn.ts";
import {ColDef} from "ag-grid-community";
import {ExtraDisplayColumnMethodOptions} from "@/utils/common/ListViewUtils.ts";
import AGGridHTMLCellRenderer from "@/components/inputs/AGGridHTMLCellRenderer.vue";

export default class AGGridHTMLColumn extends AGGridColumn {

  constructor(column: namaTypes.ListScreenColumn, entityType: string) {
    super(column, entityType);
  }

  override createColDef(extraOptions: ExtraDisplayColumnMethodOptions): ColDef {
    let colDef = AGGridColumn.defaultColDef(this.column, this.entityType, extraOptions.layout);
    colDef.cellRenderer = AGGridHTMLCellRenderer;
    colDef.autoHeight = true;
    return colDef;
  }
}
